// KAN-619 — helpers de consentimento de cookies para o site institucional.
// Reflete o esquema usado no zenthor_app (chave separada pra que cada origin
// tenha seu próprio consentimento — site institucional roda em vorseum.com,
// app em zenthor.vorseum.com).

export const CONSENT_VERSION = "2026-05";
const CONSENT_KEY = "vorseum_consent_v1";
const SIX_MONTHS_MS = 6 * 30 * 24 * 60 * 60 * 1000;

export interface CookieConsent {
  version: string;
  analytics: boolean;
  marketing: boolean;
  decidedAt: number;
}

export function getStoredConsent(): CookieConsent | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    const consent = JSON.parse(raw) as CookieConsent;
    if (consent.version !== CONSENT_VERSION) return null;
    if (Date.now() - consent.decidedAt > SIX_MONTHS_MS) return null;
    return consent;
  } catch {
    return null;
  }
}

export function saveConsent(analytics: boolean, marketing: boolean): CookieConsent {
  const consent: CookieConsent = {
    version: CONSENT_VERSION,
    analytics,
    marketing,
    decidedAt: Date.now(),
  };
  localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
  const maxAge = 6 * 30 * 24 * 60 * 60;
  document.cookie = `consent_v1=${analytics ? "analytics" : "necessary"};max-age=${maxAge};path=/;SameSite=Lax`;
  return consent;
}
